/* tslint:disable */

/**
 */
export class PipeLineElmt {
    ELMT_PRICE?: number;
    ID_PIPELINE_ELMT?: number;
    ID_COOLING_FAMILY?: number;
    LINE_VERSION?: number;
    LINE_RELEASE?: number;
    LINE_DATE?: string;
    LINE_COMMENT?: string;
    MANUFACTURER?: string;
    ELT_TYPE?: number;
    INSULATION_TYPE?: number;
    ID_USER?: number;
    ELT_SIZE?: number;
    ELT_LOSSES_1?: number;
    ELT_LOSSES_2?: number;
    ELT_IMP_ID_STUDY?: number;
    OPEN_BY_OWNER?: number;
    CODE_LANGUE?: number;
    ID_TRANSLATION?: number;
    TRANS_TYPE?: number;
    LABEL?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/pipe-line-elmt.ts